/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyboxRecordsInfo.vue?vue&type=template&id=51a183a3&scoped=true"
import script from "./popLuckyboxRecordsInfo.vue?vue&type=script&lang=js"
export * from "./popLuckyboxRecordsInfo.vue?vue&type=script&lang=js"
import style0 from "./popLuckyboxRecordsInfo.vue?vue&type=style&index=0&id=51a183a3&prod&lang=scss&scoped=true"
import style1 from "./popLuckyboxRecordsInfo.vue?vue&type=style&index=1&id=51a183a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a183a3",
  null
  
)

export default component.exports